import { ProductLabel as BaseProductLabel } from "@/components/Product/Layout/ProductLabel/productLabel.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useCashbackContext } from "../../context/cashback.context";

export const ProductLabel = () => {
    const { t } = useGranite();

    const { cashbackAmount, cashbackUnit } = useCashbackContext();

    return (
        <BaseProductLabel
            text={t("promotionLabel.cashback")}
            secondary={`${cashbackAmount}${cashbackUnit}`}
        />
    );
};
